/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { SmsVerifyAnalyticsDelivery } from './smsVerifyAnalyticsDelivery';
import { SmsVerifyAnalyticsDroppedMessages } from './smsVerifyAnalyticsDroppedMessages';
import { SmsVerifyAnalyticsUndeliveredMessages } from './smsVerifyAnalyticsUndeliveredMessages';
import { SmsVerifyAnalyticsUnverifiedMessages } from './smsVerifyAnalyticsUnverifiedMessages';
import { SmsVerifyAnalyticsVerification } from './smsVerifyAnalyticsVerification';

export interface SmsVerifyAnalyticsResponse { 
    messageParts?: number;
    sent?: number;
    dropped?: number;
    delivery?: SmsVerifyAnalyticsDelivery;
    verification?: SmsVerifyAnalyticsVerification;
    droppedMessages?: SmsVerifyAnalyticsDroppedMessages;
    undeliveredMessages?: SmsVerifyAnalyticsUndeliveredMessages;
    unverifiedMessages?: SmsVerifyAnalyticsUnverifiedMessages;
}
